/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractChangeStatusEnumDTO } from './contract-change-status-enum-dto';


/**
 * Defines a contract status change based on the status and month.
 */
export interface ContractStatusChangeDTO { 
    /**
     * Month, since when the change takes effect.
     */
    from: string;
    status: ContractChangeStatusEnumDTO;
}

export class ClsContractStatusChangeDTO { 
    /**
     * Month, since when the change takes effect.
     */
    from: string = undefined;
    status: ContractChangeStatusEnumDTO = undefined;
}



